module.exports = __webpack_public_path__ + "static/3_years_stacked-ebf54b5dd0a5596e2d8d5abe5e0f1a09.png";